import React, { useRef, useState, useMemo, forwardRef, useImperativeHandle, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes, useEffect } from 'react';
import { AssetModuleTable } from '@/asset/AssetModuleTable';
import { cloneDeep } from 'lodash';
import { Button, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

export interface MdmCpartBomTableProps {
  value: any;
  filterProps: any;
  metaConfig: any;
  activeKey?: string | undefined;
  activeData?: any;
  mainRecordValue: any;
  showTreeList: any[];
  showTreeData: any;
  _headIdField?: string;
  headIdData?: string;
  onChange: (data: any, isDefault?: boolean) => void;
}

export const MdmCpartBomTable: React.FC<MdmCpartBomTableProps> = (props) => {
  const {
    value = [],
    filterProps,
    activeKey,
    activeData,
    metaConfig,
    mainRecordValue,
    _headIdField,
    headIdData,
    showTreeData,
    showTreeList,
    onChange,
    refList,
    ...otherProps
  } = props;
  const tableRef = useRef<any>();

  const getDefualtValues = async (treeList: any[]) => {
    const isCreate = metaConfig.pageType === 'add';
    if (isCreate) {
      const list = treeList?.map((el: any) => {
        const newItem: any = {
          bd_material_classification_number: el.bd_material_classification_number,
          md_bbom_template_line_id: el.md_bbom_template_line_id,
          md_cpart_product_base_info_product_code: mainRecordValue?.cpart_code,
        };
        if (_headIdField) {
          newItem[_headIdField] = headIdData;
        }
        return newItem;
      });
      onChange && onChange(list, true);
    }
  };

  const addLine = () => {
    if (value.filter((el: any) => activeKey && el[filterProps?.filterField] === activeKey).length > 0) {
      message.warning('每个节点的部件需求只要一条');
      return;
    }
    const fieldName = filterProps?.filterField;
    const oldValues = cloneDeep(value);
    const newItem: any = {
      [fieldName]: activeKey,
    };
    if (filterProps?.mapFields && filterProps.mapFields.length > 0) {
      filterProps.mapFields.forEach((el: any) => {
        if (el.tableField && el.treeField) {
          newItem[el.tableField] = activeData[el.treeField];
        }
      });
    }
    if (_headIdField) {
      newItem[_headIdField] = headIdData;
    }
    oldValues.push(newItem);
    onChange && onChange(oldValues);
  };

  useEffect(() => {
    if (showTreeList && showTreeList.length > 0) {
      getDefualtValues(showTreeList);
    }
  }, [showTreeList]);

  const validateFields = () => {
    return new Promise(async (resolve, reject) => {
      try {
        await tableRef.current?.validateFields();
      } catch (err) {
        console.log('err', err)
        reject(err);
      }
      const isRequiredCol = otherProps.columns?.filter((el: any) => el.isRequired)?.map((el: any) => el.dataIndex);
      let flag = true;
      value?.forEach((val: any) => {
        isRequiredCol.forEach((col: string) => {
          if (!val[col]) {
            flag = false;
          }
        });
      });
      if (flag) {
        resolve({
          module: otherProps.moduleID,
          validateFields: flag,
        });
      } else {
        reject({
          module: otherProps.moduleID,
          validateFields: flag,
        });
      }
    });
  };

  useEffect(() => {
    refList?.current.delete(`${otherProps.moduleID},${headIdData}`);
    refList?.current.set(`${otherProps.moduleID},${headIdData}`, {
      validateFields,
    });
  }, [value]);

  return (
    <>
      <AssetModuleTable
        {...otherProps}
        key={activeKey || 'all'}
        onChange={(val: any) => {
          if (activeKey) {
            const oldValue = cloneDeep(value);
            let ind = -1;
            const newValue = oldValue.map((el: any) => {
              if (el[filterProps?.filterField] === activeKey) {
                ind++;
                return val[ind] || el;
              }
              return el;
            });
            onChange && onChange(newValue);
          }
        }}
        value={value.filter((el: any) => activeKey && el[filterProps?.filterField] === activeKey)}
        ref={tableRef}
        rowDelable={false}
        optionColumns={false}
        toolBarRender={[
          <>
            {activeKey && metaConfig?.pageType !== 'view' && (
              <Button type="primary" ghost onClick={addLine}>
                <PlusOutlined /> 新建
              </Button>
            )}
          </>,
        ]}
      />
    </>
  );
};

export default MdmCpartBomTable;
